const COLORS = require("../data/colors.js");
const g = require("three");
require("./utils.js");
var h;
const j = [
  {
    stp: 0,
    col: null,
  },
  {
    stp: 0.5,
    col: null,
  },
  {
    stp: 1,
    col: null,
  },
];
class k extends g.Object3D {
  static fromConfig(l, m) {
    return new k(
      l,
      m.skyDomeCol0,
      m.skyDomeCol1,
      m.skyDomeCol2,
      m.skyDomeEmis,
      m.skyDomeTex,
      m.skyDomeMovD,
      m.skyDomeMovT,
    );
  }
  constructor(q, w, x, z, A, B, C, D) {
    super();
    var E = {
      src: "sky_6",
      emissive: A || null,
      movT: D != null && D / 1000000,
      movD: C,
    };
    h = new g.MeshBasicMaterial({
      color: 16777215,
      depthWrite: false,
      flatShading: false,
      vertexColors: g.VertexColors,
      side: g.BackSide,
      transparent: true,
    });
    if (B) {
      q.loadTexture(h, E.src, E);
      if (E.emissive) {
        q.loadTexture(h, E.src + "_e", E, "emissiveMap");
      }
    }
    j[0].col = new g.Color(w || COLORS.skyDome[0]);
    j[1].col = new g.Color(x || COLORS.skyDome[1]);
    j[2].col = new g.Color(z || COLORS.skyDome[2]);
    let F = new g.SphereGeometry(50, 32, 32);
    F.computeBoundingBox();
    let G = F.boundingBox;
    let H = new g.Vector3().subVectors(G.max, G.min);
    let I = ["a", "b", "c"];
    let J = new g.Vector3();
    let K = 0;
    for (let M, N = 0; N < j.length - 1; N++) {
      M = j[N + 1].stp - j[N].stp;
      for (let O, P = 0; P < F.faces.length; P++) {
        O = F.faces[P];
        for (var L = 0; L < 3; L++) {
          K = J.subVectors(F.vertices[O[I[L]]], G.min).divide(H).y;
          K = 1 - K;
          if (K >= j[N].stp && K <= j[N + 1].stp) {
            O.vertexColors[L] = j[N].col
              .clone()
              .lerp(j[N + 1].col, (K - j[N].stp) / M);
          }
        }
      }
    }
    F.computeVertexNormals(true);
    F.computeFaceNormals();
    this.baseMesh = new g.Mesh(F, h);
    this.baseMesh.doubleSided = false;
    this.add(this.baseMesh);
  }
}
module.exports = k;
